module.exports = __webpack_public_path__ + "img/CCNA-LOGO-lite.a305c635.png";